const useStyles = () => {
    return {
        accordion: {
            padding: '8px 16px',
            margin: 0,
            '& .MuiAccordionSummary-content': {
                margin: 0
            },
            '&.Mui-expanded': {
                margin: 0
            },
            '& .Mui-focusVisible': {
                backgroundColor: 'transparent'
            },
            '& .MuiAccordionSummary-root': {
                cursor: 'default !important', /* Asegúrate de usar !important si es necesario */
              }
        },
        see: {
            width: 'fit-content'
        },
        titleContainer: {
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 2
        },
        amount: {
            flex: '0 1 30px',
            height: '30px',
            minWidth: '30px',
            borderRadius: '100%',
            backgroundColor: 'c_red.main',
            padding: '5px',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

        },
        info: {
            flex: '1 0 200px',
            display: 'flex',
            gap: 2,
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        date: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'end',
            alignItems:  'end',
            width: 'max-content',
            '& .MuiTypography-root': {
                textAlign: 'end'
            },
            '& .max-content': {
                width: 'max-content',
            }
        },
        right: {
            display: 'flex',
            gap: 4
        },
        comment: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            paddingBottom: 2
        },
        addorment: {
            alignItems: 'start',
            position: 'relative',
            bottom: '-10px',
            right: '-10px'
        },
        actions: {
            display: 'flex',
            alignItems: 'center',
            '& .MuiIconButton-root': {
                fontSize: '1.5rem',
                '& .MuiSvgIcon-root': {
                    fontSize: 'inherit'
                }
            }
        },
        rotate: (expand: boolean) => ({
            transition: '200ms',
            transform: `rotate(${expand ? '180deg' : '0deg'})`,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        }),
        description: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        mainContainer: {
            display: 'flex', 
            flexDirection: 'column', 
            height: '90vh', 
        },
    }
}

export { useStyles }
